import { useCheckoutContext } from "context/checkout-context";
import { ReactComponent as CrossSign } from "assets/cross-sign.svg";
import "./index.scss";
import { toMoneyWithMaximumTwoDecimalDigits } from "utils/currency";

export const CheckoutSummaryGcxCash = ({ closeCouponArea }) => {
  const {
    checkoutData: { points },
    handleGcxCash
  } = useCheckoutContext();

  const isPointsApplied = points.applied;

  const handleClick = () => {
    if (isPointsApplied) {
      closeCouponArea();
    }

    handleGcxCash(!isPointsApplied);
  };

  return (
    <div className="checkout-summary-gcx-cash">
      <div className="label">
        <button className="label-button" onClick={handleClick}>
          {isPointsApplied ? (
            <CrossSign alt="cross" className="button-sign cross" />
          ) : (
            <span className="button-sign plus">+</span>
          )}
        </button>
        <p className="label-text">&nbsp;{points.label}:</p>
      </div>
      <p className="amount">
        {toMoneyWithMaximumTwoDecimalDigits(points.amount)}
      </p>
    </div>
  );
};
